<template>
  <v-flex xs4 md4>
    <v-card class="text-center py-6" flat tile>
      <h2 class="display-2 blue--text font-weight-black"><animated-int :value="value"/></h2>
      <h4 class="subtitle-2 text-uppercase">{{label}}</h4>
    </v-card>
  </v-flex>
</template>
<script>
import AnimatedInt from '../AnimatedInt'

export default {
  components: {AnimatedInt},
  props: {
    label: {
      required: true
    },
    value: {
      required: true,
    }
  }
}
</script>
